// NewsList.js
import React from 'react';
import { FixedSizeList as List } from 'react-window';
import NewsArticle from "../../modules/News/components/NewsArticle";
import Button from '@mui/material/Button';
import { ExpandMoreRounded } from '@mui/icons-material';
import { Row, Col, Card } from 'antd';

const ARTICLES_PER_PAGE = 5;

const NewsList = ({
  articles,
  onLoadMore,
  screenHeight,
}) => {

  const renderRow = ({ index, style }) => {
    const article = articles[index];
    return (
      <div style={style}>
        <NewsArticle
          article={article}
          isSpotlight={index < 2}
        />
      </div>
    );
  };

  return (
    <div className="flex flex-col gap-4 min-h-[75vh] max-w-[80vw] hide-scrollbar">
      {articles.length > 0 ? (
        <List
            className={'hide-scrollbar mx-auto'}
          height={screenHeight * 0.7} // Adjust height based on available space
          itemCount={articles.length}
          itemSize={140} // Adjust item height as needed
          width="100%"
        >
          {renderRow}
        </List>
      ) : (
        <Card>
          <p>No articles found matching the selected filters.</p>
        </Card>
      )}
        {onLoadMore && (
            <Row justify={'center'}>
                <Col>
                    <Button
                      variant={'outlined'}
                      size={'large'}
                      onClick={onLoadMore}
                      startIcon={<ExpandMoreRounded />}
                      className="w-96 load-more-button pill"
                    >
                      Load More
                    </Button>
                </Col>
            </Row>
        )}
    </div>
  );
};

export default NewsList;
